/* eslint-disable */
import { createApp } from "vue"
import App from "./App.vue"
import { router } from "@/router/index"
import "@/assets/css/index.css"
import { createPinia } from "pinia"

import { applyBrand } from "@/utilities/brand"

import CloudflareTurnstile from "@/components/CloudflareTurnstile.vue"
import CardHeaderBackdrop from "@/components/CardHeaderBackdrop.vue"
import TwBadgeFlat from '@/components/Badges/TwBadgeFlat.vue'
import TwButton from '@/components/Buttons/TwButton.vue'
import TwInput from '@/components/InputGroups/TwInput.vue'
import TwLoading from '@/components/Loading/TwLoading.vue'
import SimpleStat from '@/components/Stats/SimpleStat.vue'
import TwModal from '@/components/Modals/TwModal.vue'
import TwTable from '@/components/Tables/TwTable.vue'
import TwTableColumn from '@/components/Tables/TwTableColumn.vue'
import TwTableDropdown from '@/components/Tables/TwTableDropdown.vue'
import TwTableHeader from '@/components/Tables/TwTableHeader.vue'
import TwTableRow from '@/components/Tables/TwTableRow.vue'
import VNotification from "./components/Notifications/VNotification.vue"
import VNotificationTitle from "./components/Notifications/VNotificationTitle.vue"
import VNotificationDescription from "./components/Notifications/VNotificationDescription.vue"
import VAlert from "./components/Alert/VAlert.vue"
import VAlertActions from "./components/Alert/VAlertActions.vue"
import VAlertBody from "./components/Alert/VAlertBody.vue"
import VAlertDescription from "./components/Alert/VAlertDescription.vue"
import VAlertTitle from "./components/Alert/VAlertTitle.vue"
import VButton from "./components/Buttons/VButton.vue"
import VDivider from "./components/Dividers/VDivider.vue"
import VDividerLabel from "./components/Dividers/VDividerLabel.vue"
import VHeading from "./components/Headings/VHeading.vue"
import VSubheading from "./components/Headings/VSubheading.vue"
import VText from "./components/Text/VText.vue"
import VStrong from "./components/Text/VStrong.vue"
// configure amplify
import { Amplify } from 'aws-amplify'
import awsconfig from './aws-exports'

Amplify.configure(awsconfig)

Amplify.configure({
	API: {
		endpoints: [
		  {
			name: "fmDataAPI",
			endpoint: process.env.VUE_APP_API_URL,
		  }
		],
	}
})

Amplify.configure({
    authenticationFlowType: "USER_PASSWORD_AUTH"
})

// resolve the hostname's brand before mount so the palette is set for the first paint
applyBrand()

const pinia = createPinia()
const app = createApp(App)

app.component("cloudflare-turnstile", CloudflareTurnstile)
app.component("card-header-backdrop", CardHeaderBackdrop)
app.component("tw-badge-flat", TwBadgeFlat)
app.component("tw-button", TwButton)
app.component("tw-loading", TwLoading)
app.component("tw-input", TwInput)
app.component("tw-simple-stat", SimpleStat)
app.component("tw-table", TwTable)
app.component("tw-table-column", TwTableColumn)
app.component("tw-table-dropdown", TwTableDropdown)
app.component("tw-table-header", TwTableHeader)
app.component("tw-table-row", TwTableRow)
app.component("tw-modal", TwModal)
app.component("v-notification", VNotification)
app.component("v-notification-title", VNotificationTitle)
app.component("v-notification-description", VNotificationDescription)
app.component("v-alert", VAlert)
app.component("v-alert-title", VAlertTitle)
app.component("v-alert-description", VAlertDescription)
app.component("v-alert-body", VAlertBody)
app.component("v-alert-actions", VAlertActions)
app.component("v-button", VButton)
app.component("v-divider", VDivider)
app.component("v-divider-label", VDividerLabel)
app.component("v-heading", VHeading)
app.component("v-subheading", VSubheading)
app.component("v-text", VText)
app.component("v-strong", VStrong)
app.use(pinia)
app.use(router)
app.mount("#app")
